import { render, staticRenderFns } from "./MaridajeRed.vue?vue&type=template&id=c8189f60&scoped=true&"
import script from "./MaridajeRed.vue?vue&type=script&lang=js&"
export * from "./MaridajeRed.vue?vue&type=script&lang=js&"
import style0 from "./MaridajeRed.vue?vue&type=style&index=0&id=c8189f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8189f60",
  null
  
)

export default component.exports